import { render, staticRenderFns } from "./DiseaseUpdate.vue?vue&type=template&id=bd433ee4&scoped=true"
import script from "./DiseaseUpdate.vue?vue&type=script&lang=js"
export * from "./DiseaseUpdate.vue?vue&type=script&lang=js"
import style0 from "./DiseaseUpdate.vue?vue&type=style&index=0&id=bd433ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd433ee4",
  null
  
)

export default component.exports